import { IApiClient } from '@api/core/api.client';

export class BaseApi {
  constructor(protected readonly client: IApiClient) {}
}
